const urlParams = new URLSearchParams(window.location.search);

export const isEditable = (editable = true) => {
  return (
    urlParams.get(process.env.REACT_APP_ROLE_CODE) !==
      process.env.REACT_APP_ROLE_VISITOR &&
    urlParams.get(process.env.REACT_APP_ROLE_CODE) !==
      process.env.REACT_APP_ROLE_READ_ONLY &&
    editable
  );
};

export const isReadOnly = () => {
  return (
    urlParams.get(process.env.REACT_APP_ROLE_CODE) ===
    process.env.REACT_APP_ROLE_READ_ONLY
  );
};

export const isGlobalAdmin = () => {
  return (
    urlParams.get(process.env.REACT_APP_ROLE_CODE) ===
      process.env.REACT_APP_ROLE_MJ
  );
};

export const isMJ = () => {
  const mj_access = window.localStorage.getItem('mj_access');
  const hasAccess = mj_access !== null && mj_access !== undefined;
  return hasAccess === true;
};

export const linkWithMJparam = item => {
  const mj_access = window.localStorage.getItem('mj_access');
  const hasAccess = mj_access !== null && mj_access !== undefined;
  return hasAccess
    ? `${process.env.REACT_APP_ROLE_CODE}=${process.env.REACT_APP_ROLE_MJ}`
    : '';
};
